import { render, staticRenderFns } from "./customer-custom-field.vue?vue&type=template&id=1d80cbd1&"
import script from "./customer-custom-field.vue?vue&type=script&lang=js&"
export * from "./customer-custom-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports